import React from 'react';

import { Image } from '@/components/Image';
import contentConfig from '@/modules/content/config';
import { ContentEntity, ResourceTypeEnum } from '@/types/schema';

interface Params {
  className?: string;
  survey: ContentEntity;
  width: number;
  height: number;
}

const { icons } = contentConfig[ResourceTypeEnum.Survey];

export const renderSurveyContentImage = ({ survey, className, width, height }: Params) => {
  if (!icons) {
    return null;
  }

  const { image } = icons.getContentImage(survey);

  if (image) {
    return (
      <Image alt={survey.name} className={className} height={height} src={image} width={width} />
    );
  }

  return null;
};
